
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'SideNavLink',
  props: {
    to: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    }
  }
})
